import type { PermissionService } from "../PermissionService";
import type { ScopedViewPermissionAttributes } from "./AbstractScopedViewVoter";
import { PermissionAttributesEnum } from "@verbleif/lib/src/composables/Permissions/permissions.enum";
import { AbstractScopedViewVoter } from "./AbstractScopedViewVoter";

export class ReportViewVoter extends AbstractScopedViewVoter {
  protected readonly attrs: ScopedViewPermissionAttributes = {
    readAny: PermissionAttributesEnum.GlobalOperationReportviewReadany,
    createAny: PermissionAttributesEnum.GlobalOperationReportviewCreateany,
    updateAny: PermissionAttributesEnum.GlobalOperationReportviewUpdateany,
    deleteAny: PermissionAttributesEnum.GlobalOperationReportviewDeleteany,
    read: PermissionAttributesEnum.ContextOperationReportviewRead,
    create: PermissionAttributesEnum.ContextOperationReportviewCreate,
    update: PermissionAttributesEnum.ContextOperationReportviewUpdate,
    delete: PermissionAttributesEnum.ContextOperationReportviewDelete,
    readCollectionViaClient: PermissionAttributesEnum.ContextOperationReportviewReadcollectionviaclient,
    readCollectionViaLocation: PermissionAttributesEnum.ContextOperationReportviewReadcollectionvialocation,
    readCollectionViaPtg: PermissionAttributesEnum.ContextOperationReportviewReadcollectionviaptg,
    readCollectionGlobal: PermissionAttributesEnum.ContextOperationReportviewReadcollectionglobal,
    readEffective: PermissionAttributesEnum.ContextOperationReportviewReadeffective,
    readDefinitionSchema: PermissionAttributesEnum.ContextOperationReportviewReaddefinitionschema,
  };

  constructor(permissionService: PermissionService) {
    super(permissionService);
  }
}
